import {get} from "./api/apiHelper";

// Converts snake_case / lowercase master data values to a readable label.
// e.g. 'joint' → 'Joint', 'non_vegetarian' → 'Non Vegetarian', 'passed_away' → 'Passed Away'
export const formatMstLabel = (val) =>
  val ? val.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : val;

export const convertUtcToIst = (utcTimestamp) => {
  let utcDate = new Date(utcTimestamp);
  if (isNaN(utcDate)) throw new Error("Invalid date format!");
  let istDate = new Date(utcDate.getTime() + 19800000); 
  return `${String(istDate.getDate()).padStart(2, "0")}/${String(
    istDate.getMonth() + 1
  ).padStart(2, "0")}/${istDate.getFullYear()} - ${String(
    istDate.getHours()
  ).padStart(2, "0")}:${String(istDate.getMinutes()).padStart(2, "0")}`;
};


export const convertToIST = (utcDate) => {
  if (!utcDate) return "N/A"; 

  const date = new Date(utcDate);
  
  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};


export const convertUtcToIstWithTime = (utcTimestamp) => {
  const utcDate = new Date(utcTimestamp);
  if (isNaN(utcDate)) return "NA";

  return utcDate.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour12: false,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};



export const TableRow = ({ data }) => {
  return (
    <tr>
      {data.map((item, index) => (
        <td key={index} className="p-2 border border-gray-300 w-1/3">
          <p className="text-xs text-gray-500">{item.label}</p>
          <p className="text-sm font-medium text-gray-800">
            {item.value || "N/A"}
          </p>
        </td>
      ))}
      {data.length < 3 &&
        [...Array(3 - data.length)].map((_, i) => (
          <td key={i} className="p-2 border border-gray-300"></td>
        ))}
    </tr>
  );
};


export const createLoadOptions = (model, pageSize = 50, religionId="") => {
  let debounceTimer;
  let currentPage = 1;
  let inputCache = "";



  return (inputValue, callback) => {
    if (inputValue !== inputCache) {
      currentPage = 1;
      inputCache = inputValue;
    }

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async () => {
      try {
        const params = {
          page: currentPage,
          limit: pageSize,
          query: inputValue,
        };

        const res = await get(`mst-admin/${model}/search-mst-data`, { params });


        if (res?.data?.data) {

          const rawData = religionId
          ? res.data.data.filter(
              (each) =>
                each.religionLabelId?.toString() === religionId.toString()
            )
          : res.data.data;

        
           const  options= rawData.map((item) => ({
              value: item.id || item._id,
              label: item.label || "N/A",
            })) ;

          callback(options);

          if (res.data.hasMore) {
            currentPage += 1;
          }
        } else {
          callback([]);
        }
      } catch (error) {
        console.error("Dropdown load error:", error);
        callback([]);
      }
    }, 300);
  };
};

export const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "#BA7C3B" : base.borderColor,
    boxShadow: state.isFocused ? "0 0 0 2px #BA7C3B66" : base.boxShadow,
    "&:hover": { borderColor: "#BA7C3B" },
  }),
};


export const formatDate = (date) => {
  console.log(date,"this is date")
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


export const convertToISO = (dateStr) => {
  if (typeof dateStr !== "string" || !dateStr) {
    return null;
  }
  
  const parts = dateStr.split("-");
  
  // Must have exactly 3 parts
  if (parts.length !== 3) {
    return null;
  }
  
  // If first part is 4 digits, assume it's already ISO format, but do basic validation
  if (parts[0].length === 4) {
    const [year, month, day] = parts;
    if (isValidDateComponents(year, month, day)) {
      return dateStr;
    }
    return null;
  }
  
  // Otherwise assume dd-MM-yyyy format
  const [day, month, year] = parts;
  
  if (!isValidDateComponents(year, month, day)) {
    return null;
  }
  
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

// Helper function to validate date parts are numbers and within valid ranges
const isValidDateComponents = (year, month, day) => {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  
  if (
    Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d) ||
    y < 1000 || y > 9999 || // basic year range check
    m < 1 || m > 12 ||
    d < 1 || d > 31
  ) {
    return false;
  }
  
  // Additional check for valid days in month and leap years
  const date = new Date(y, m - 1, d);
  return (
    date.getFullYear() === y &&
    date.getMonth() === m - 1 &&
    date.getDate() === d
  );
};







    
